import React from "react";
import { Box } from "@mui/material";
import { useDraggable } from "@dnd-kit/core";
import { DeliveryPickingCard } from "./DeliveryPickingCard";

type DraggablePickingCardProps = {
  item: any;
  stageId: number | string;
  stageColor?: string;
  userTimezone: string;
  isSelected: boolean;
  onToggle: (itemId: number, checked: boolean) => void;
  disabled?: boolean;
};

export const DraggablePickingCard = React.memo(function DraggablePickingCard({
  item,
  stageId,
  stageColor,
  userTimezone,
  isSelected,
  onToggle,
  disabled = false,
}: DraggablePickingCardProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: item.id,
    data: {
      type: "picking",
      stageId,
      item,
    },
    disabled,
  });

  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      sx={{
        opacity: isDragging ? 0.25 : 1,
        contentVisibility: "auto",
        containIntrinsicSize: "auto 120px",
      }}
    >
      <DeliveryPickingCard
        item={item}
        stageColor={stageColor}
        userTimezone={userTimezone}
        isSelected={isSelected}
        onToggle={onToggle}
        dragListeners={disabled ? undefined : listeners}
        isDragSource={isDragging}
      />
    </Box>
  );
});
